:root {
  --size: 522px;
}

section.wheel {
  user-select: none;
  position: relative;
  width: var(--size) !important;
  height: calc(100vh - 2rem);
  background: url(../../assets/skillwheel/backdrop_skillwheel.png?as=webp) no-repeat center top;
}

section.wheel::before {
  content: '';
  display: block;
  position: absolute;
  pointer-events: none;
  left: 0;
  right: 0;
  width: var(--size);
  height: var(--size);
  transform: rotate(var(--rotation));
  transition: transform 0.25s;
  background: var(--bgfront) no-repeat center top;
}

section.wheel section {
  margin-top: 1rem;
  position: relative;
}

section.wheel section article:first-child {
  grid-template-rows: 2rem auto;
  grid-template-columns: 2rem 1fr;
}

section.wheel section article:first-child pre {
  max-width: 100%;
  grid-column-start: 1;
  padding-left: 0.5rem;
}

section.wheel section article:first-child em {
  --size: 30px;
}

section.wheel section article:nth-child(2) {
  padding-left: 0.5rem;
}

section.wheel fieldset {
  border: none;
  padding: 0;
  display: flex;
  gap: 0.25rem;
  justify-content: center;
  margin-top: 0.5rem;
}

section.wheel fieldset button {
  padding: 0.25rem 0.5rem;
}

section.wheel fieldset span {
  align-self: center;
  font-size: 1.1em;
  padding: 0 1rem;
}
